import { Locale } from 'config/constants/locales';
import { isSupportedLocale } from 'utils/is-supported-locale';
import { useConfig } from 'config/use-config';
import { useIntl } from 'react-intl';

/**
 * Narrows the react-intl from string to Locale.
 */
export const useLocale = (): Locale => {
  const { locale } = useIntl();
  const { locale: defaultLocale } = useConfig();

  return isSupportedLocale(locale) ? locale : defaultLocale;
};
